import { useResourceContext } from "@/layouts/ResourceContext";
import { useNavigate } from "react-router-dom";
/**
 * This resource navigate hook is used to navigate to the resource.
 * It will handle the navigation to the resource.
 * 
 * <TODO> It will handle the tenants mode.
 * 
 * @returns 
 */
export const useResourceNavigate = () => {
  const navigate = useNavigate();
  const { rootState, dispatch } = useResourceContext();
  return ({ resource, key, action, queryParam }, options) => {
    if (resource === 'tenants' && action === 'enter') {
      if (resource.tenantName !== key) {
        dispatch({ type: 'TENANT_MODE', payload: { tenantName: key } });
      }
      navigate(`/t/${key}`);
      return;
    }
    let prefix = '';
    if (rootState.tenantName) {
      prefix = `/t/${rootState.tenantName}`;
    }
    action === "create"
      ? navigate(`${prefix}/${resource}/${action}`, options)
      : action === 'list'
      ? navigate(`${prefix}/${resource}` + (queryParam ? queryParam : ""), options)
      : navigate(`${prefix}/${resource}/${action}/${key}` + (queryParam ? queryParam : ""), options);
  };
};